import ValueEmitter_vue_vue_type_script_setup_true_lang_default from "./ValueEmitter.vue.script.js";
//#region src/v2/components/layout/ValueEmitter.vue
var ValueEmitter_default = ValueEmitter_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ValueEmitter_default as default };

//# sourceMappingURL=ValueEmitter.vue.js.map